import React, { ReactNode } from "react"

import Grid from "@ecom/ui/components/Grid"
import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import { FirstCard, SecondCard, SecondCardAuraCard, SecondCardPlanetaCard } from "./img"
import * as styles from "./otherCards.module.scss"
import { SecondCardBG } from "./img/SecondCardBG"

interface IOtherCards {
  title?: ReactNode
  firstCardText?: ReactNode
  secondCardText?: ReactNode
  orderNum?: string
  variantStyle?: "planetacard" | "auracard"
}

const OtherCards = ({
  title = "Рефинансируйте другие кредитные карты",
  firstCardText = "Переведите долги по кредитным картам до 300 000 ₽ на Халву",
  secondCardText = "Наслаждайтесь рассрочкой* 24 месяца",
  orderNum,
  variantStyle,
}: IOtherCards) => {
  const renderImageSecondCard = () => {
    switch (variantStyle) {
      case "planetacard":
        return <SecondCardPlanetaCard alt="planetacard" className={styles.secondImage} />
      case "auracard":
        return <SecondCardAuraCard alt="auracard" className={styles.secondImage} />
      default:
        return <SecondCard alt="карта Совкомбанк" className={styles.secondImage} />
    }
  }

  return (
    <section
      className={clsx(styles.otherCards, variantStyle && styles[variantStyle])}
      data-exclude={orderNum}
    >
      <Container>
        <h2>{title}</h2>

        <Grid container spacing={2} className={styles.cardsBlock}>
          <Grid className={styles.firstCard} item xs={12} sm={6}>
            <h3 className={styles.cardText}>{firstCardText}</h3>
            <FirstCard alt="карта Совкомбанк" className={styles.firstImage} />
          </Grid>
          <Grid className={styles.secondCard} item xs={12} sm={6}>
            <h3 className={styles.cardText}>{secondCardText}</h3>
            <SecondCardBG alt="" className={styles.secondBG} />
            {renderImageSecondCard()}
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}

export default OtherCards
